import React from "react";
import styles from "./TestPage.module.css";

const TestPage = () => {
  return (
    <div className={styles.container}>
      <h1>🌍 Global & Variables Test</h1>

      <section className={styles.section}>
        <h2>✅ Typography</h2>
        <p>기본 폰트 및 색상 테스트</p>
        <p className={styles.small}>작은 글씨 (var(--font-size-sm))</p>
        <p className={styles.large}>큰 글씨 (var(--font-size-lg))</p>
      </section>

      <section className={styles.section}>
        <h2>✅ Buttons</h2>
        <button className="primary">Primary Button</button>
      </section>

      <section className={styles.section}>
        <h2>✅ Flexbox Utils</h2>
        <div className="flex space-between">
          <div className={styles.box}>Box 1</div>
          <div className={styles.box}>Box 2</div>
        </div>
      </section>

      <section className={styles.section}>
        <h2>✅ Scrollbar Test</h2>
        <div className={styles.scrollArea}>
          <p>스크롤이 있는 박스입니다.</p>
          <p>스크롤바 스타일을 확인하세요.</p>
          <p>여러 줄을 추가합니다.</p>
          <p>여러 줄을 추가합니다.</p>
          <p>여러 줄을 추가합니다.</p>
          <p>여러 줄을 추가합니다.</p>
        </div>
      </section>
    </div>
  );
};

export default TestPage;
